import SharedFooter from '@/components/share/footer'
var Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'signup',
  components: {
    SharedFooter
  },
  computed: {
    api () {
      return this.$store.getters.api
    }
  },
  data () {
    return {
      formParam: {
        email: '',
        password: '',
        password_confirmation: '',
        invitation_cd: '',
        emailError: '',
        passwordError: '',
        passwordConfirmError: '',
        isPush: false
      },
      isConfirm: false,
      isSuccess: false,
      message: '',
      isAlert: false,
      error: {},
      validation: {
        username: false,
        password: false
      },
      tab: '1',
      introducer: {}
    }
  },
  methods: {
    signup () {
      this.formParam.isPush = true

      let v = new Validator({
        'email': this.formParam.email,
        'password': this.formParam.password,
        'password_confirmation': this.formParam.password_confirmation
      }, {
        'email': 'required|email',
        'password': 'required|min:8|confirmed',
        'password_confirmation': 'required|min:8'
      })

      let pass = v.passes()

      this.formParam.emailError = v.errors.first('email')
      this.formParam.passwordError = v.errors.first('password')
      this.formParam.passwordConfirmError = v.errors.first('password_confirmation')

      if (!pass) {
        this.formParam.isPush = false
      } else {
        this.$cognito.signUp(this.formParam.email, this.formParam.password)
          .then(cognitoUser => {
            this.tab = '2'
            this.formParam.isPush = false
          })
          .catch(err => {
            this.isAlert = true
            this.error = err
            this.formParam.isPush = false
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/signup/signup.js